export const AUTH_FAILURE_STATUSES: readonly number[] = [401, 403];

export function isAuthFailureStatus(status: number): boolean {
  return AUTH_FAILURE_STATUSES.includes(status);
}
